<div class="dvb-error">
    @if (useHtml) {
        <div [innerHTML]="errorMessage"></div>
    }
    @if (!useHtml) {
        <p>{{ errorMessage }}</p>
    }
</div>
